<template>
    <div class="qualification_class">
        <div class="back" @click="jumpGo"> <a-button type="primary">资质审核申请</a-button></div>
        <a-tabs v-model:activeKey="activeKey" @change="tabChange">
            <a-tab-pane v-for="item in  tabList " :key="item.value" :tab="item.name">
                <div class="query-item">
                    <div class="search-l">
                        <div class="ml5">
                            车架号
                            <a-input class="inp ml24" placeholder="请输入" v-model:value="query.carNum"></a-input>
                        </div>
                        <a-button class="ml24" @click="search" type="primary" ghost>查询</a-button>
                        <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
                        <div></div>
                    </div>
                </div>

                <div class="big_item mt24 ml5">
                    <div class="item" v-for="item in  list " :key="item.id" :style="setStyle(item)">

                        <div class="flex aic jcsb topStatus" style="padding: 13px 18px 14px 18px;">
                            <div class="border">
                                <div class="card_title">{{ item.carTestNum ? item.carTestNum : '牌照申请中' }}</div>
                            </div>

                            <div class="tips" v-if="activeKey == 2 && item.remainderDay > 0">离资质到期还有 {{
            item.remainderDay }}天
                            </div>

                            <div class="right_status" :style="setStatusColor(item)">

                                <img style="margin-bottom: 2px;" :src="getStatusIcon(item)" alt="">
                                {{ getStatusText(item) }}
                            </div>
                        </div>
                        <div class="main_box">
                            <div class="flex aic jcsb" style="padding: 0 20px 0 18px;">
                                <div class="card_left">测试类型：</div>
                                <div class="card_right">{{ getSingleTypeValue(appStore.SysDictVOList,
            'testType' + 'category' + item.category) }}</div>
                            </div>
                            <div class="flex aic jcsb" style="padding: 12px 20px 0 18px;">
                                <div class="card_left">车辆类型：</div>
                                <div class="card_right">
                                    {{ getSingleTypeValue(appStore.SysDictVOList, 'carInfo' + 'category' + item.carType)
                                    }}
                                    <!-- {{ item.carType }} -->
                                </div>
                            </div>
                            <div class="flex aic jcsb" style="padding: 12px 20px 0 18px;">
                                <div class="card_left">车架号：</div>
                                <div class="card_right">{{ item.carFrameNum }}</div>
                            </div>
                            <div class="flex aic jcsb" v-if="!item.checkResultJointGroup"
                                style="padding: 12px 20px 0 18px;">
                                <div class="card_left">申请时间：</div>
                                <div class="card_right">{{ item.createTime }}</div>
                            </div>
                            <div class="flex aic jcsb" v-if="activeKey == 2 && item.checkResultJointGroup == 1"
                                style="padding: 12px 20px 0 18px;">
                                <div class="card_left">同意时间：</div>
                                <div class="card_right">{{ moment(item.checkResultJointGroupTime).format("YYYY-MM-DD HH:mm:ss")  }}</div>
                            </div>
                            <div class="flex aic jcsb" style="padding: 12px 20px 9px 18px;">
                                <div class="card_left">测试有效期:</div>
                                <div class="card_right">{{ item.testStartTime }}至{{ item.testEndTime }}</div>
                            </div>
                        </div>
                        <div class="card_footer">
                            <div class="card_detail" @click="detail(item)"><i class="iconfont icon-xiangqing"></i> 详情
                            </div>
                            <img style="margin-top: 20px;;height: 37.29px;" v-if="activeKey === 0"
                                src="../../assets/images/shu.png" alt="">
                            <div class="card_detail" v-if="activeKey === 0" @click="edit(item)"
                                style="padding: 0 42px 0 44px;"><i class="iconfont icon-bianji"></i> 编辑
                            </div>
                            <img style="margin-top: 20px;;height: 37.29px;" src="../../assets/images/shu.png"
                                v-if="activeKey === 0" alt="">
                            <div class="card_detail" @click="revoke(item)" v-if="activeKey === 0"><i
                                    class="iconfont icon-chexiaoshenqingicon"></i> 撤销申请</div>

                            <div :class="['card_btn', 'yanqi', item.delayFlag ? '' : 'gray_btn']" @click="apply(item)"
                                v-if="activeKey === 2 && item.checkCauseMsg == '审批通过' && item.checkFlowNode != 4">
                                <span>延期申请</span>
                            </div>
                            <div class="card_btn" @click="edit(item, 'againUpdate')"
                                v-if="activeKey === 1 && item.checkFlowNode == 3">提交修改</div>
                        </div>
                    </div>
                </div>

                <a-pagination style="position: fixed;right: 45px; bottom: 20px;" @change="pageChange"
                    v-model:current="pageIndex" v-model:page-size="pageSize" :total="total"
                    :show-total="total => `共有 ${total} 条数据`" :showSizeChanger="true" :showQuickJumper="false" />

            </a-tab-pane>
        </a-tabs>

        <applyModal ref="applyModalRef" :id="qid" :testEndTime="testEndTime" @applyFinished="getData()" />

    </div>
</template>
<script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted, watch, onActivated } from 'vue'
import moment from "moment";
import { useRouter, useRoute } from 'vue-router'
import { Modal, message } from 'ant-design-vue'
import applyModal from './components/modal'
import useAppStore from "@/store/modules/app";
import { qualificationList, deleteEntityAndRels, checkQualificationDate } from '@/api/qualification/index'
import { getSingleTypeValue } from "@/utils/matchDic.js";

const router = useRouter()
const appStore = useAppStore();
const route = useRoute()

import useUserStore from "@/store/modules/user";

const store = useUserStore();

const activeKey = ref(0);

const tabList = ref([
    { value: 0, name: '待审批' },
    { value: 1, name: '审批中' },
    { value: 2, name: '已审批' },
])

let query = reactive({
    carNum: "",
});

const list = ref([])

const picture = ref(require('../../assets/images/pending_card.png'))  // 接数据 判断

const jumpGo = () => {
    console.log(store.res);
    if (!store.res) {
        message.error('企业不存在')
    } else if (store.res.status == 0) {
        message.error('提示该企业已禁用，无法创建资质/任务')
    } else {
        router.push({
            path: "/qualificationManage/detail",
            query: {
                type: 'add'
            }
        });
    }

}


const pageIndex = ref(1);
const pageSize = ref(10);
const total = ref(10)

const search = () => {
    pageIndex.value = 1;
    getData();
};

const reset = () => {
    query.carNum = "";
    pageIndex.value = 1;
    getData();
};

const tabChange = val => {
    console.log(val);
    getData();
}

const pageChange = (page, pageSize) => {
    console.log(page, pageSize)
    pageIndex.value = page
    getData()
}


const getData = () => {
    const data = {
        pageIndex: pageIndex.value,
        pageSize: pageSize.value,
        conditionMap: { ...query, status: activeKey.value },

    };
    list.value = [];
    qualificationList(data).then((res) => {

        list.value = res.data.records || [];
        total.value = res.data.total;
    });

}

function detail(row) {
    console.log(row)
    router.push({
        path: "/qualificationManage/examineDetail",
        query: {
            id: row.id,
            type: 'detail',
            from: "1"  //返回路由 qualificationManage/index
        }
    });
}

function edit(row, againUpdate) {
    router.push({
        path: "/qualificationManage/detail",
        query: {
            id: row.id,
            type: 'edit',
            againUpdate: true
        }
    });
}

const applyModalRef = ref();
const qid = ref();
const testEndTime = ref('')
function apply(row) {
    console.log(row);
    if (row.delayFlag) {
        qid.value = row.id;
        testEndTime.value = row.testEndTime
        setTimeout(() => {
            applyModalRef.value.show();
        }, 100);

    }

}

function revoke(row) {
    Modal.confirm({
        title: '确定撤销该条申请?',
        onOk() {
            deleteEntityAndRels({ id: row.id }).then(res => {
                if (res.code == 200) {

                    getData();
                    setTimeout(() => {
                        message.success("撤销成功");
                    }, 300);

                } else {
                    message.error(res.msg);
                }
            })
        },
        onCancel() { },
    });
}

//获取审批状态
function getStatusText(row) {
    let str = "";
    if (activeKey.value == 0) {
        //待审批
        str = "等待审批";
    } else if (activeKey.value == 1) {
        //审批中
        switch (row.checkFlowNode) {
            case 0:
                str = "材料审核";
                break;
            case 1:
                str = "专家组审核";
                break;
            case 2:
                str = "联席小组审核";
                break;
            case 3:
                str = "材料审核不通过";
                break;
            case 4:
                str = "资质失效";
                break;
            default:
                str = "审核中";
                break;
        }
    } else {
        //已审批
        if (row.checkIsPass) {
            str = "审批通过";
            if (row.checkFlowNode == 4) {
                str = "已失效";
            }
        } else {
            str = "审批不通过  " + row.checkCauseMsg;
        }
    }
    return str;
}

//设置状态文字图标
function getStatusIcon(row) {
    let img = '';
    if (activeKey.value == 0) {
        img = require('../../assets/images/pending_orange.png');
    } else if (activeKey.value == 1) {
        img = require('../../assets/images/center_blue.png');
    } else {
        if (row.checkIsPass) {
            img = require('../../assets/images/success.png');
            if (row.checkFlowNode == 4) {
                //资质失效
                img = require('../../assets/images/stop.png');
            }
        } else {
            img = require('../../assets/images/error.png');
        }
    }

    return img;
}

function setStatusColor(row) {
    let color = "";
    if (activeKey.value == 0) {
        color = '#E86D14';
    } else if (activeKey.value == 1) {
        color = '#1482E8';
    } else {
        color = '#2AA328';
        if (row.checkIsPass) {
            if (row.checkFlowNode == 4) {
                //资质失效
                color = '#7D7D7D';
            }
        } else {
            color = '#F90000';
        }
    }
    return { 'color': color }
}

//设置item背景样式
function setStyle(row) {
    let style = '';
    if (activeKey.value == 0) {
        style = `background:url(${require('../../assets/images/pending_card.png')})`
    } else if (activeKey.value == 1) {
        style = `background:url(${require('../../assets/images/center_card.png')})`
    } else {
        if (row.checkIsPass) {
            style = `background:url(${require('../../assets/images/success_green.png')})`
            if (row.checkFlowNode == 4) {
                //资质失效
                style = `background:url(${require('../../assets/images/success_gray.png')})`
            }
        } else {
            style = `background:url(${require('../../assets/images/success_red.png')})`
        }
    }
    return style;
}






onActivated(() => {
  // 获取路由参数
    const carFrameNum = route.query.carFrameNum;
    const actKey = +route.query.activeKey;
    if (carFrameNum){
        query.carNum = carFrameNum;
    }
    if (actKey){
      activeKey.value = actKey;
    }
    getData()
})

</script>
<style lang="less" scoped>
.qualification_class {
    padding: 13px 20px 20px 20px;
    height: calc(100vh - 70px - 57px);
    background-color: #ffffff;
}

.back {
    position: fixed;
    top: 93px;
    right: 50px
}

.inp {
    width: 13.5vw;
}

.query-item {
    display: flex;
    justify-content: space-between;

    .search-l {
        display: flex;
    }

    .search-r {
        display: flex;
    }
}

.big_item {
    display: flex;
    flex-wrap: wrap;
    height: 62vh;
    overflow: auto;
    margin-bottom: 39px;

    .item {
        width: 445px;
        height: 310px;
        font-family: PingFang SC, PingFang SC;
        font-size: 14px;
        margin-right: 12px;
        margin-bottom: 24px;

        .topStatus {
            position: relative;

            .tips {
                position: absolute;
                top: 10px;
                left: 137px;
                width: 98px;
                color: #2288FF;
            }
        }

        .main_box {
            height: 167px;
        }

        .border {
            border: 2px solid #1677D1;
            width: 102px;
            padding: 1px;
            border-radius: 6px 6px 6px 6px;

            .card_title {
                width: 96px;
                height: 32px;
                background: #1677D1;
                border-radius: 6px 6px 6px 6px;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 16px;
                line-height: 32px;
                text-align: center;
            }
        }




        .card_left {
            width: 126px;
            text-align: left;
            font-weight: 400;
            font-size: 14px;
            color: #636D7B;
        }

        .card_right {
            width: 183px;
            text-align: right;
            font-weight: 400;
            font-size: 14px;
            color: #1F598F;
        }

        .card_footer {
            font-size: 16px;
            color: #fff;
            height: 75px;
            line-height: 75px;
            display: flex;
            justify-content: space-between;

            .card_detail {
                padding: 0 41px 0 37px;
                cursor: pointer;
            }

            .card_btn {
                width: 100px;
                height: 32px;
                margin: 22px 41px 21px 0;
                background: #3678B5;
                box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.25);
                border-radius: 6px 6px 6px 6px;
                border: 1px solid #E7F3FF;
                line-height: 32px;
                text-align: center;
                cursor: pointer;
            }

            .gray_btn {
                cursor: not-allowed;
                background: rgb(125, 125, 125);
                border: 1px solid #999;
            }
        }
    }


}

.big_item .item:nth-child(4n+4) {
    margin-right: 0;
}

.ml5 {
    margin-left: 5px;
}

.mt24 {
    margin-top: 24px;
}

/deep/.ant-tabs .ant-tabs-tab {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    margin: 0 0 0 70px;
    color: rgba(29, 33, 41, 0.7);
}

/deep/.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    color: #1D2129;
}



/deep/.ant-tabs-top>.ant-tabs-nav .ant-tabs-ink-bar {
    height: 3px;
    // background: rgba(30, 142, 242, 1);
}

/deep/.ant-upload-wrapper .ant-upload-list {
    width: 130px;
}
</style>
